<template>
  <div class="addPro">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>展品/新增展品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <div class="desc">
      <p>规则说明：</p>
      <p>1，企业须承诺所参与的新品不存在抄袭及侵权情况，如发生侵权纠纷，主办方将立即停止对于该产品的一切展示。并由企业承担相应的法律责任。</p>
      <p>2，新品描述性文字需真实准确，不存在蓄意夸大及虚假情况。</p>
    </div> -->
    <el-row>
      <el-col :span="18" :offset="2">
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="productForm" label-position="right"  label-width="200px">
          <template v-for="(item,ind) in allList">
              <template v-if="item.fieldKey != 'pdtLogo' && item.fieldKey != 'typID'">
                  <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                    <el-input  :type=" ( item.fieldKey == 'pdtIntro' ||  item.fieldKey == 'pdtEIntro' ) ? 'textarea': 'text'"  v-model="form[item.fieldKey]" :placeholder='item.fieldHolder'></el-input>
                  </el-form-item>
              </template>

              <template v-if="item.fieldKey == 'typID'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" >
                     <el-option :label="val.typName" :value="val.typID" v-for="(val) in classTypeList" :key="val.typID"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'pdtLogo'">
                  <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                    <el-input v-model="form[item.fieldKey]" style="display:none"/>
                    <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" :typeString = '"P"' />
                  </el-form-item>
              </template>

          </template>
          <!-- <div class="mz">
            <p>*免责声明</p>
            <p>所有上传内容均由参展企业自主上传，与天津国展中心立场无关。主办方不对其中包含或引用的信息的准确性、可靠性或完整性提供任何明示或暗示的保证。如因上传的文字内容触犯中华人民共和国法律，上传企业应自行承担全部责任 如任何单位或个人认为新品系统所展示的内容涉嫌侵犯其合法权益，应及时向天津国展中心提出书面意见并提供相关证明材料和理由，收到上述文件后将采取相应措施。</p>
          </div> -->
          <el-form-item class="btns">
            <el-button size="medium" type="primary" :style="buttonStyle" @click="onSubmit">提交</el-button>
            <el-button size="medium" @click="back">返回</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../../utils/tools.js';
import { validateEnCompany, validateChineseZipCode, validateEmail } from '@/utils/validator'
export default {
  data () {
    return {
      "id": `${this.$route.query.id}` === 'undefined' ? '' : `${this.$route.query.id}`,
      form: {},
      classTypeList:[],
      rules: {},
      allList:[],
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
    }
  },

  components: {
    Upload
  },
  mounted() {
    this.getProductType()
    this.getsaasfield()
  },

  methods: {
      //获取展品分类
      getProductType(){
        api.searchproducttype().then((res)=>{
            if(res.data.code =='200'){
              var _data = res.data.data
              this.classTypeList = _data
            }
        })
      },
  rulesFn(item){
      var temp = ''
      var rulesData= {
        pdtLogo: [{ required: item.required, trigger: 'change', message: '请'+item.fieldName}],
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'},
      }
      switch (item.fieldKey){
      case 'pdtLogo':
          temp = item.fieldKey
          break;
      default: 
          temp = 'other'
          break
      }
      return rulesData[temp]
    },
      getsaasfield(){
        api.getsaasfield({type:"product"}).then(res => {
          if (res.data.code === 200) {
            this.allList =[]
            var _data = res.data.data
            for(var i = 0;i<_data.length;i++){
                if(_data[i].enable == 1){
                  this.allList.push(_data[i])
                }
            }
            for(var j=0;j<this.allList.length;j++){
              this.$set( this.form,this.allList[j].fieldKey,"")
            }
            this.$nextTick(() => {
                if(this.id !=''){
                    api.productinfo({id : this.id}).then((res)=>{
                        if(res.data.code =='200'){
                          var _data = res.data.data
                          for (let i in this.form) {
                              this.form[i] = _data[i]?''+_data[i]+'':''
                          }
                        }
                    })
                }
            })
          }
        })
    },
    changeSelect(val){
       this.form.typID = val
    },
    onSubmit() {
      for (let i in this.form) {
        if( typeof this.form[i] != 'object'){
            this.form[i] = (this.form[i]).toString().replace(/^\s+|\s+$/g,"")
        }
      }

      this.$refs['productForm'].validate((valid) => {
        if (valid) {
          var paramt = JSON.parse(JSON.stringify(this.form))
          if(this.id !=''){
            paramt.id = parseInt( this.id)
          }

          paramt.typID = parseInt(this.form.typID) 
          api.saveproduct(paramt).then((res) => {
            if (res.data.code === 200) {
                this.$notify({
                  title: '保存成功',
                  type: 'success'
                })
                this.$router.go(-1)
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.blue {
  color: #409eff;
}

.title {
  margin-bottom: 30px;
}

.col-1-fix {
  padding-left: 0 !important;
}
.desc{
  font-size: 14px;
  line-height: 18px;
  padding: 10px;
}
.mz{
  font-size:14px;
  color:#999;
}
.btns{
  text-align: center;
  padding-top: 15px;
}
@media screen and (max-width:540px){
  .addPro{
    .el-form-item__label{
      font-size:14px;
    }
    .el-input--small .el-input__inner{
      border:0;
      text-align: right;
      padding-right: 45px;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .el-form-item__error{
      text-align: right;
      width:100%;
    }
  }
}
</style>
